import { ChatWidget } from "./components/ChatWidget";
import styles from "./App.module.css";

// These three are promises, so the bot has to keep them. It used to decline
// the AI and video-editing ones outright — the page sold two things and the
// first message refused them, reported as the scope contradicting its own
// landing page. AERO is Dell's sales agent for the whole range now, so they
// are back and they are honoured.
const EXAMPLES = [
  "Play modern games smoothly at high settings",
  "Run large AI models locally",
  "Edit high-resolution video smoothly",
];

export function App() {
  return (
    <main className={styles.shell}>
      <section className={styles.hero}>
        <p className={styles.kicker}>PHASE 1 · SPEC ADVISOR</p>
        <h1 className={styles.h1}>AERO</h1>
        <p className={styles.lead}>
          Tell it the game, app, or AI model you're targeting. It runs a live
          web search for the real requirements and specs the Dell that actually
          keeps up — not one that just "meets minimum".
        </p>

        <ul className={styles.examples}>
          {EXAMPLES.map((e) => (
            <li key={e} className={styles.example}>
              “{e}”
            </li>
          ))}
        </ul>
      </section>

      <ChatWidget />
    </main>
  );
}
